import type { ViewEventModel } from 'functions/app/event/view'
import type { CollectedEventData } from './eventTypes'

export const buildPreviewEvent = (data: CollectedEventData): ViewEventModel => {
  const {
    generalInfo,
    locationCover,
    locationType,
    eventSettings,
    coverImages,
    existingImages,
  } = data

  return {
    id: 0,
    slug: 'preview',
    uuid: 'preview',
    title: generalInfo?.title ?? '',
    intro: generalInfo?.intro ?? '',
    content: generalInfo?.content ?? '',
    start: generalInfo?.start ? new Date(generalInfo.start).getTime() : 0,
    end: generalInfo?.end ? new Date(generalInfo.end).getTime() : 0,
    isCrowdBuildingEvent: false,
    meetingLink: locationType === 'online' ? (locationCover?.meetingLink ?? '') : '',
    limit: eventSettings?.limit ?? 0,
    location:
      locationType === 'offline' && locationCover?.address
        ? { address: locationCover.address }
        : undefined,
    images: [
      ...(existingImages ?? []).map((img) => ({ src: img.src })),
      ...coverImages.map((img) => ({ src: img.preview })),
    ],
  }
}
